import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import {
  Apps,
  BarChart,
  GitHub,
  LinkedIn,
  LocalCafe,
  LocationCity,
  Lock,
  PhotoCamera,
  SportsEsports
} from '@material-ui/icons'
import CyberpunkDropdown from 'components/CustomDropdown/CyberpunkDropdown.js'
import Button from 'components/CustomButtons/Button.js'

const cyberpunkHeaderLinksStyles = makeStyles({
  list: {
    fontSize: '14px',
    margin: 0,
    paddingLeft: '0',
    listStyle: 'none',
    paddingTop: '0',
    paddingBottom: '0',
    color: 'inherit'
  },
  listItem: {
    float: 'left',
    color: 'inherit',
    position: 'relative',
    display: 'block',
    width: 'auto',
    margin: '0',
    padding: '0',
    '&:hover': {
      background: 'rgba(255, 0, 255, 0.1)',
      borderRadius: '4px',
    }
  },
  navLink: {
    color: '#00ffff !important',
    position: 'relative',
    padding: '0.9375rem',
    fontWeight: '400',
    fontSize: '12px',
    textTransform: 'uppercase',
    borderRadius: '3px',
    lineHeight: '20px',
    textDecoration: 'none',
    margin: '0px',
    display: 'inline-flex',
    fontFamily: '"Orbitron", monospace',
    letterSpacing: '0.05em',
    textShadow: '0 0 5px rgba(0, 255, 255, 0.5)',
    transition: 'all 0.3s ease',
    '&:hover,&:focus': {
      color: '#ff00ff !important',
      textShadow: '0 0 10px rgba(255, 0, 255, 0.7)',
      transform: 'translateY(-1px)',
    }
  },
  dropdownLink: {
    fontSize: '13px',
    padding: '5px 20px',
    display: 'block',
    textDecoration: 'none',
    fontWeight: '400',
    color: '#00ffff !important',
    fontFamily: '"Share Tech Mono", monospace',
    textShadow: '0 0 3px rgba(0, 255, 255, 0.3)',
    transition: 'all 0.3s ease',
    '&:hover,&:focus': {
      color: '#ff00ff !important',
      background: 'rgba(255, 0, 255, 0.1)',
      textShadow: '0 0 8px rgba(255, 0, 255, 0.6)',
    }
  },
  icons: {
    width: '17px',
    height: '17px',
    marginRight: '4px',
    filter: 'drop-shadow(0 0 3px rgba(0, 255, 255, 0.5))',
    transition: 'all 0.3s ease',
  },
  tooltip: {
    padding: '10px 15px',
    minWidth: '130px',
    color: '#00ffff',
    lineHeight: '1.7em',
    background: 'rgba(10, 10, 10, 0.95)',
    border: '1px solid rgba(255, 0, 255, 0.3)',
    borderRadius: '3px',
    fontStyle: 'normal',
    fontWeight: '400',
    textShadow: 'none',
    fontFamily: '"Share Tech Mono", monospace',
    textDecoration: 'none',
    textTransform: 'none',
    letterSpacing: 'normal',
    wordBreak: 'normal',
    wordSpacing: 'normal',
    wordWrap: 'normal',
    whiteSpace: 'normal',
    lineBreak: 'auto',
    fontSize: '12px',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 0 15px rgba(255, 0, 255, 0.3)',
  }
})

export default function CyberpunkHeaderLinks (props) {
  const classes = cyberpunkHeaderLinksStyles()
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <CyberpunkDropdown
          noLiPadding
          buttonText="[SIDE_PROJECTS]"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent'
          }}
          buttonIcon={Apps}
          dropdownList={[

            <a key="hushwire" href="https://hushwire.vercel.app" target="_blank"
               className={classes.dropdownLink} rel="noreferrer"
               style={{ display: 'flex', alignItems: 'center' }}>
              <Lock style={{ marginRight: '8px', filter: 'drop-shadow(0 0 3px rgba(255, 0, 255, 0.5))' }}/>
              Hushwire
            </a>,
            <a key="pixfeed" href="https://pixfeed.vercel.app" target="_blank"
               className={classes.dropdownLink} rel="noreferrer"
               style={{ display: 'flex', alignItems: 'center' }}>
              <PhotoCamera style={{ marginRight: '8px', filter: 'drop-shadow(0 0 3px rgba(255, 0, 255, 0.5))' }}/>
              PixFeed
            </a>,
            <a key="poke-tasks" href="https://poketasks.vercel.app/" target="_blank"
               className={classes.dropdownLink} rel="noreferrer"
               style={{ display: 'flex', alignItems: 'center' }}>
              <SportsEsports style={{ marginRight: '8px', filter: 'drop-shadow(0 0 3px rgba(255, 0, 255, 0.5))' }}/>
              PokeTasks
            </a>,
            <a key="sg-housing" href="https://sg-housing.streamlit.app/" target="_blank"
               className={classes.dropdownLink} rel="noreferrer"
               style={{ display: 'flex', alignItems: 'center' }}>
              <BarChart style={{ marginRight: '8px', filter: 'drop-shadow(0 0 3px rgba(255, 0, 255, 0.5))' }}/>
              Singapore Housing
            </a>,
            <a key="sg-austin" href="https://austin-housing.streamlit.app/" target="_blank"
               className={classes.dropdownLink} rel="noreferrer"
               style={{ display: 'flex', alignItems: 'center' }}>
              <LocationCity style={{ marginRight: '8px', filter: 'drop-shadow(0 0 3px rgba(255, 0, 255, 0.5))' }}/>
              Austin Housing
            </a>
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="https://www.linkedin.com/in/schanjr/"
          color="transparent"
          target="_blank"
          className={classes.navLink}
        >
          <LinkedIn className={classes.icons}/>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="https://github.com/schanjr"
          color="transparent"
          target="_blank"
          className={classes.navLink}
        >
          <GitHub className={classes.icons}/>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          href="https://schanjr.wordpress.com"
          color="transparent"
          target="_blank"
          className={classes.navLink}
        >
          <LocalCafe className={classes.icons}/>
        </Button>
      </ListItem>
    </List>
  )
}
